import { createApp } from 'vue'

import App from './App.vue'
import router from './router'
import store from './store'

import ElementPlus from 'element-plus'

import 'element-plus/dist/index.css'
import '../theme/ele-theme-sop/src/index.scss'
import '@/styles/tailwind.css'
import '@/styles/index.scss'
import 'virtual:svg-icons-register'
import '@purge-icons/generated'

import GuideRemind from '@/views/components/GuideRemind/index'
// import { notificationHandler } from '@/utils/notificationHandler'

import '@/utils/cache/persistent'

import 'vant/lib/index.css'
import '@vant/touch-emulator'

createApp(App)
  .use(router)
  .use(store)
  .use(ElementPlus, {
    namespace: 'sp' // 修改 element-plus 组件前缀
  })
  .use(GuideRemind)
  .mount('#app')

// notificationHandler()
